import React from "react";
import Details from '../homepage/details/Details';
import LessonNominee from '../homepage/lessonNominee/LessonNominee';
import MakeContact from '../homepage/makeContact/MakeContact'
import VideoPromotion from '../homepage/videoPromotion/VideoPromotion'
import About from "../homepage/about/about";
import VideoPromotionLahav from "../homepage/videoPromotionLahav/videoPromotionLahav";


function LangindPage(){
    return(
    <>
    <VideoPromotion homepage={false}/>
    <About homepage={false}/>
    <LessonNominee homepage={false}/>
    <Details homepage={false}/>
    <VideoPromotionLahav />
    <MakeContact page='landing-page'/>
    </>
    )
}

export default LangindPage;